import type { ReactNode } from 'react';

export const symbol_car_fan_mid_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M396.11-55q-10.89-6-14-18Q379-85 385-96l127-217q8.17-14.25 21.91-22.13Q547.66-343 564-343h111l62-223q9-32 34.47-52.5Q796.93-639 829-639q43.6 0 71.3 33.5Q928-572 920-528l-46 238q-3.73 21-20.54 34.5Q836.66-242 815-242H541L437-66q-5.85 10.82-17.93 13.91Q407-49 396.11-55ZM849.2-698q-29.2 0-50.2-20.8-21-20.79-21-50 0-29.2 20.8-50.2 20.79-21 50-21 29.2 0 50.2 20.8 21 20.79 21 50 0 29.2-20.8 50.2-20.79 21-50 21ZM253-521q-8-8-8.5-20.5T252-563l96-98H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-721 110-721h239l-96-96q-9-8.8-9-20.9 0-12.1 9-21.1 9-9 21-9t21 9l148 147q5 5 7 10.13 2 5.14 2 11 0 5.87-2 10.87-2 5-7 10L295-521q-9 9-21 9t-21-9Z"
		/>
	</svg>
);
